export const BannerPositions = {
  TOP: 'top',
  REGULAR: 'regular',
  AFTER_FIRST_ROW: 'afterFirstRow',
};

export const BannerTypes = {
  TOP: '1',
  REGULAR: '0',
  AFTER_FIRST_ROW: '2',
};
